import { RecipeCoreId, RecipeUUID } from '@library/menu-service'

import { useCurrentCollectionId } from 'hooks/menu-collections'
import { useCollectionRecipes } from 'routes/Menu/domains/menu'

export const useBaseRecipeId = (recipeId: RecipeUUID | null): RecipeCoreId | undefined => {
  const currentCollectionId = useCurrentCollectionId()
  const currentCollectionRecipeSets = useCollectionRecipes(currentCollectionId)

  const recipeSet = currentCollectionRecipeSets.find(({ recipe }) => recipe.id === recipeId)

  return recipeSet?.originalId
}
